import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { CqrsService } from '@common/services/cqrs.service';
import { User } from '@common/models/User';
import { AdministrationPermissions, VesselVisitPermissions } from '@common/classes/permissions';
import { VesselVisitStatusCodes } from '@common/classes/vessel-visit-status-codes';

@Injectable({
  providedIn: 'root'
})
export class VesselVisitEditableCheckService {
  editPermission = VesselVisitPermissions.Action.Edit;

  constructor(
    private cqrs: CqrsService,
    private toastrService: ToastrService,
    private translateService: TranslateService
  ) {}

  async canEdit(id: string, user: User): Promise<boolean> {
    const model = await this.cqrs.query('VesselVisit', { id });

    // some checks are made on backend to see if user can edit vessel visit, if he can't null is returned
    if(model === undefined || model === null){
      this.toastrService.error(this.translateService.instant('User does not have neccessary permission to edit vessel visit'));
      return false;
    }

    if (!this.hasEditPermission(user)) {
      this.toastrService.error(this.translateService.instant('User does not have neccessary permissions to edit vessel visits'));
      return false;
    }

    if (!this.isEditable(model, user)) {
      this.toastrService.error(this.translateService.instant('Vessel visit is not editable!'));
      return false;
    }

    return this.isEditable(model, user);
  }

  hasEditPermission(user: User, editPermission?: string): boolean {
    if (editPermission) {
      return user.hasPermission(editPermission);
    }
    return true;
  }

  isEditable(model: any, user: User): boolean {
        // RM 43067 VesselVisit EDIT logic update
        const preStatus = VesselVisitStatusCodes.Preannounced;

        // If PRE status, allow edit if user has edit permission
        if (model.status?.id === preStatus) {
            return this.hasEditPermission(user, this.editPermission);             
        }

        // For all other statuses, only superuser can edit
        return this.isAdminUser(user);
  }

  isAdminUser(user: User){
      return user.isSystemUser || user.hasPermission(AdministrationPermissions.User.ViewAll);
  }  
}